import React, { useState } from 'react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 2000);
  };

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>Have questions or need help? We'd love to hear from you!</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <h3>Get in Touch</h3>
              <p>We're here to help with any questions about purse trading, platform features, or general inquiries.</p>
            </div>
            
            <div className="contact-item">
              <h3>Email</h3>
              <p>contactooowap@gmail.com</p>
            </div>
            
            <div className="contact-item">
              <h3>Phone</h3>
              <p>(754) 800-4472</p>
              <p style={{fontSize: '0.9rem', color: '#888', marginTop: '0.5rem'}}>Calling hours: 9-5pm M-F</p>
            </div>
            
            <div className="contact-item">
              <h3>Response Time</h3>
              <p>We typically respond within 24 hours during business days.</p>
            </div>
            
            <div className="contact-item">
              <h3>Follow Us</h3>
              <p><a href="https://facebook.com/ooowapdotcom" target="_blank" rel="noopener noreferrer">Facebook.com/ooowapdotcom</a></p>
              <p><a href="https://www.tiktok.com/@ooowap.com" target="_blank" rel="noopener noreferrer">TikTok.com/@ooowap.com</a></p>
              <p><a href="https://instagram.com/ooowapdotcom" target="_blank" rel="noopener noreferrer">Instagram.com/ooowapdotcom</a></p>
              <p><a href="https://youtube.com/@ooowap" target="_blank" rel="noopener noreferrer">YouTube.com/@ooowap</a></p>
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  placeholder="What's this about?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  placeholder="Tell us more about your inquiry..."
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <p>Thank you for your message! We'll get back to you soon.</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 